module.exports = __webpack_public_path__ + "img/2.1.670f16e1.png";